export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const CLOSE_SIDE_MENU = 'CLOSE_SIDE_MENU';
export const OPEN_SIDE_MENU = 'OPEN_SIDE_MENU';
export const SET_AVATAR_MODAL_IS_OPEN = 'SET_AVATAR_MODAL_IS_OPEN';